var _defs, _path, _g, _path2, _path3, _path4, _path5, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomTeamRequests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196.97,
    height: 222.369,
    viewBox: "0 0 196.97 222.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2044",
    "data-name": "Rectangle 2044",
    width: 70.026,
    height: 206.705,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2048",
    "data-name": "Rectangle 2048",
    width: 108.679,
    height: 169.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2047",
    "data-name": "Rectangle 2047",
    width: 108.678,
    height: 169.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2045",
    "data-name": "Rectangle 2045",
    width: 57.76,
    height: 77.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2046",
    "data-name": "Rectangle 2046",
    width: 37.915,
    height: 50.734,
    fill: "#699dee"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22239",
    "data-name": "Group 22239",
    transform: "translate(-836.072 -212.008)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11341",
    "data-name": "Path 11341",
    d: "M152.018,352.337c0,4.264-34.03,7.72-76.009,7.72S0,356.6,0,352.337s34.03-7.721,76.009-7.721,76.009,3.457,76.009,7.721",
    transform: "translate(881.023 74.32)",
    fill: "#7586ec",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22238",
    "data-name": "Group 22238",
    transform: "translate(0.111 14.008)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22227",
    "data-name": "Group 22227",
    transform: "translate(944.64 205.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22226",
    "data-name": "Group 22226",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11478",
    "data-name": "Path 11478",
    d: "M214.546,917.791a23.434,23.434,0,0,1,1.6-6.008c1.12-2.24,8.249-.815,8.249-.815s1.426,1.222,1.731,6.925Z",
    transform: "translate(-167.577 -711.188)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11479",
    "data-name": "Path 11479",
    d: "M22.683,900.988c1.675-1.022.722-8.649.722-8.649s-7.8-6.244-8.878-1.463S7.112,897.8,3.5,898.387c-2.492.4-3.263,1.784-3.5,2.6Z",
    transform: "translate(0 -694.436)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11480",
    "data-name": "Path 11480",
    d: "M82.587,482.417a35.97,35.97,0,0,0-.573,4.216C81.289,500.785,70.1,533.143,68.1,533.9c-3.1,1.168-7.972-1.315-10.523-2.128a2.188,2.188,0,0,1-1.535-2.485c5.54-25.469,7.576-62.144,8.317-83.858a98.532,98.532,0,0,1,2.252-18.492s27.286-7.28,27.447,1.929c.144,8.149-9.038,40.109-11.471,53.552",
    transform: "translate(-43.738 -331.336)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11481",
    "data-name": "Path 11481",
    d: "M112.422,482.417l-18.228-36.99a98.532,98.532,0,0,1,2.252-18.492s27.286-7.28,27.447,1.929c.144,8.149-9.038,40.109-11.471,53.552",
    transform: "translate(-73.573 -331.336)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11482",
    "data-name": "Path 11482",
    d: "M149.724,433.775l14.424,104.543s6.334,1.528,11.261.306c0,0,4.223-55.6,3.871-69.043s3.031-35.968-.772-38.453-28.784,2.647-28.784,2.647",
    transform: "translate(-116.946 -336.215)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11483",
    "data-name": "Path 11483",
    d: "M142.635,209.4a2,2,0,0,1-1.444,2.068c-2.012.584-4.332.99-8.806,1.917a85.411,85.411,0,0,1-16.8,1.688c-11.049.07-15.232-3.738-15.232-3.738-.476.009.251-2.3.907-13.3.222-3.725.436-8.445.591-14.412.139-5.369.234-11.747.242-19.314.012-9.1,14.1-18.895,14.361-18.895l0,0c0,1.311,2.066,3.729,5.247,3.938,3.776.247,8.409-1.633,8.409-3.807,0-.022,6.826,10.92,9.251,22.579.309,1.478.547,3.037.736,4.678.576,4.945.02,1.417,2.54,36.592",
    transform: "translate(-78.261 -113.582)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11484",
    "data-name": "Path 11484",
    d: "M89.778,145.419s-13.1-.111-16.254,4.311-10.066,28.21-6.459,36.125,10.358-3.274,14.1-8.123,8.608-32.314,8.608-32.314",
    transform: "translate(-51.59 -113.584)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11485",
    "data-name": "Path 11485",
    d: "M173.692,108.413l.007,1.354s-.369,4.235,4.846,4.854,9.1-.778,8.957-4.047a47.379,47.379,0,0,1-.952-7.236,14.734,14.734,0,0,1,.185-2.536l-10.106-.2-2.976.486Z",
    transform: "translate(-135.637 -78.577)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11486",
    "data-name": "Path 11486",
    d: "M173.653,101.087l.039,7.326a8.543,8.543,0,0,0,3.643.8c4.645,0,7.647-3.406,9.216-5.878a14.731,14.731,0,0,1,.185-2.536l-10.106-.2Z",
    transform: "translate(-135.637 -78.577)",
    fill: "#fca56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11487",
    "data-name": "Path 11487",
    d: "M177.427,37.39c-1.172,6.311-9.315,6.1-12.834,5.707-.99-.11-1.613-.237-1.613-.237-1.117-.3-1.74-2.057-2.029-4.361-.574-4.559.151-11.252.921-12.963,1.159-2.576,3.343-5.361,11.543-3.351s5.517,7.12,4.013,15.206",
    transform: "translate(-125.554 -16.791)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11488",
    "data-name": "Path 11488",
    d: "M95.681,226.4s-5.067,11.19-4.92,14.545a17.48,17.48,0,0,1,4.92.632c3.961,1.181,0-15.177,0-15.177",
    transform: "translate(-70.89 -176.835)",
    fill: "#6392dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11489",
    "data-name": "Path 11489",
    d: "M154.109,2.739A27.127,27.127,0,0,0,161.976.61c3.455-1.5,7.815.152,9.23.9a2.1,2.1,0,0,0-.345-.851,1.9,1.9,0,0,1,.729,1.08c.065.048.095.081.078.093a2.435,2.435,0,0,1,1.183.076s-.324-.046-.44.162a.2.2,0,0,1-.052.057c5.39,2.6,5.888,11.123,4.153,13.094a66.794,66.794,0,0,0-5.178,7.648,8.174,8.174,0,0,1,.056-3.284c.38-2.087-1.423-2.087-3.7-3.036s-.379-3.6-2.371-5.217-9.3-.664-9.2-1.9c-2.711-.988-2.009-6.416-2.009-6.694",
    transform: "translate(-120.307 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11490",
    "data-name": "Path 11490",
    d: "M135.567,320.43c-2.139,8.589-25.271,13.028-30.53,13.93.222-3.725.436-8.445.591-14.412Z",
    transform: "translate(-82.042 -249.905)",
    fill: "#6392dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11491",
    "data-name": "Path 11491",
    d: "M216.191,302.607a40.745,40.745,0,0,0,6.024-1.175c.881-.441,4.913-6.171,2.273-7.64s-9.729,4.408-9.729,4.408Z",
    transform: "translate(-167.743 -229.29)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11492",
    "data-name": "Path 11492",
    d: "M83.914,305.986s19.037,1.033,31.812-1.7a5.491,5.491,0,0,0-3.693-5.33s-19.911-4.22-24.694-3.045-3.425,10.077-3.425,10.077",
    transform: "translate(-65.404 -230.966)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11493",
    "data-name": "Path 11493",
    d: "M226.237,174.144c-3.951,4.764-9.115,8.653-14.809,9.564v0a10.616,10.616,0,0,1-1.409-6.358,12.724,12.724,0,0,1,2.073-5.836,12.926,12.926,0,0,0,1.12-2.257c3.109-7.933,2.646-23.222,2.646-23.222s13.2,1.383,17.317,7.26c2.52,3.6-.694,13.319-6.937,20.85",
    transform: "translate(-164.01 -114.064)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11494",
    "data-name": "Path 11494",
    d: "M165.33,103.759c-.99-.11-1.613-.237-1.613-.237-1.116-.3-1.74-2.057-2.029-4.361a5.515,5.515,0,0,1,3.453,2.823,4.053,4.053,0,0,1,.19,1.775",
    transform: "translate(-126.291 -77.453)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11495",
    "data-name": "Path 11495",
    d: "M145.593,108.344s-4.56-7.524-1.014-7.852a5.363,5.363,0,0,1,5.483,2.954c.512.882-.134,4.858-.134,4.858Z",
    transform: "translate(-111.873 -78.469)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11496",
    "data-name": "Path 11496",
    d: "M167.787,164.843a9.81,9.81,0,0,1-.777,2.613,12.509,12.509,0,0,1-2.9,4v0c-11.843-5.345-14.239-23.7-14.64-33.786-.162-4.054,0-6.772,0-6.772,5.342-1.769,6.844,1.3,6.844,1.3s6.308,15,9.58,24.8c1.252,3.751,2.059,6.743,1.9,7.84",
    transform: "translate(-116.688 -101.811)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11497",
    "data-name": "Path 11497",
    d: "M179.171,188.01c-3.951,4.764-9.115,8.653-14.809,9.564v0c-11.842-5.345-14.239-23.7-14.64-33.786,0,0,5.6,20.324,13.231,27.429a8.32,8.32,0,0,0,4.314,2.36s9.618-2.718,11.635-5.278a1.1,1.1,0,0,1,.27-.287",
    transform: "translate(-116.944 -127.93)",
    fill: "#6392dc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22237",
    "data-name": "Group 22237",
    transform: "translate(835.961 198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_22236",
    "data-name": "Mask Group 22236",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22235",
    "data-name": "Group 22235",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22234",
    "data-name": "Group 22234",
    clipPath: "url(#clip-path-3)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11498",
    "data-name": "Path 11498",
    d: "M14.958.8,94.147,47.032a11.763,11.763,0,0,1,5.876,10.184v62.529a5.883,5.883,0,0,1-8.838,5.087l-79.2-46.458A11.766,11.766,0,0,1,6.13,68.2V5.89A5.883,5.883,0,0,1,14.958.8",
    transform: "translate(8.656 -0.001)",
    fill: "#040227"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11499",
    "data-name": "Path 11499",
    d: "M13.73,1.589,92.919,47.822a11.763,11.763,0,0,1,5.876,10.184v62.529a5.883,5.883,0,0,1-8.838,5.087l-79.2-46.458A11.766,11.766,0,0,1,4.9,68.99V6.68A5.883,5.883,0,0,1,13.73,1.589",
    transform: "translate(6.922 1.114)",
    fill: "#e2e9fb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11500",
    "data-name": "Path 11500",
    d: "M6.649,21.3l48.716,28.44a7.243,7.243,0,0,1,3.613,6.266V94.475a3.62,3.62,0,0,1-5.437,3.131L4.821,69.026a7.238,7.238,0,0,1-3.6-6.259V24.437A3.619,3.619,0,0,1,6.649,21.3",
    transform: "translate(1.718 29.386)",
    fill: "#040227"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11501",
    "data-name": "Path 11501",
    d: "M5.432,22.064,54.147,50.5a7.243,7.243,0,0,1,3.613,6.266V95.235a3.62,3.62,0,0,1-5.437,3.131L3.6,69.786A7.238,7.238,0,0,1,0,63.527V25.2a3.619,3.619,0,0,1,5.432-3.133",
    transform: "translate(0 30.459)",
    fill: "#e2e9fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22230",
    "data-name": "Group 22230",
    transform: "translate(16.011 91.913)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22229",
    "data-name": "Group 22229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22228",
    "data-name": "Group 22228",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11502",
    "data-name": "Path 11502",
    d: "M12.07,38.6l48.716,28.44A7.246,7.246,0,0,1,64.4,73.3v38.464a3.62,3.62,0,0,1-5.437,3.131l-48.72-28.58a7.238,7.238,0,0,1-3.6-6.259V41.733A3.621,3.621,0,0,1,12.07,38.6",
    transform: "translate(-6.638 -38.107)",
    fill: "#699dee",
    opacity: 0.75
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22233",
    "data-name": "Group 22233",
    transform: "translate(60.28 7.972)",
    opacity: 0.75,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22232",
    "data-name": "Group 22232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22231",
    "data-name": "Group 22231",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11503",
    "data-name": "Path 11503",
    d: "M28.557,3.628,60.536,22.3a4.753,4.753,0,0,1,2.371,4.112V51.661a2.374,2.374,0,0,1-3.567,2.053L27.356,34.955a4.754,4.754,0,0,1-2.364-4.11V5.686a2.375,2.375,0,0,1,3.565-2.057",
    transform: "translate(-24.991 -3.306)",
    fill: "#699dee"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomTeamRequests);
export default __webpack_public_path__ + "static/media/custom-team-requests.ca5390597472788979bfc69b23752b4e.svg";
export { ForwardRef as ReactComponent };